import React, { useState, useEffect } from 'react'
import Cookies from 'js-cookie'
import axios from 'axios'
import { toast } from 'react-toastify'
import { FaBuilding, FaSave, FaSpinner, FaArrowLeft } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import Topbar from '../layouts/Topbar'
import Sidebar from '../layouts/Sidebar'
import Select from 'react-select'
import 'react-toastify/dist/ReactToastify.css'
import './CreateDepartment.css'
import API_BASE_URL from '../../../config/api'

const CreateDepartment = () => {
  const [costCenters, setCostCenters] = useState([])
  const [name, setName] = useState('')
  const [courseCenter, setCourseCenter] = useState(null)
  const [loading, setLoading] = useState(false)
  const [fetchingCenters, setFetchingCenters] = useState(true)
  const baseUrl = API_BASE_URL

  useEffect(() => {
    const fetchCostCenters = async () => {
      setFetchingCenters(true)
      try {
        const token = Cookies.get('token')
        const response = await axios.get(`${baseUrl}/api/course-centers/`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })
        setCostCenters(response.data)
      } catch (err) {
        toast.error('Failed to fetch cost centers.')
      } finally {
        setFetchingCenters(false)
      }
    }
    fetchCostCenters()
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    try {
      const token = Cookies.get('token')
      await axios.post(`${baseUrl}/api/departments/`, {
        name,
        course_center: courseCenter?.value
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      toast.success('Department created successfully!')
      setName('')
      setCourseCenter(null)
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to create department.')
    } finally {
      setLoading(false)
    }
  }

  const costCenterOptions = costCenters.map(center => ({
    value: center.id,
    label: center.name
  }))

  return (
    <>
      <Topbar />
      <Sidebar />
      <div className="create-department-container">
        <div className="page-header">
          <div className="header-content">
            <div className="header-left">
              <Link to="/hr/departments" className="back-button">
                <FaArrowLeft />
                <span>Back to Departments</span>
              </Link>
              <div className="page-title">
                <h1>Add Department</h1>
                <p>Create a new department and assign it to a cost center</p>
              </div>
            </div>
            <div className="header-right">
              <div className="header-icon">
                <FaBuilding />
              </div>
            </div>
          </div>
        </div>

        <div className="wrapper">
          <div className="form-container">
            <div className="form-header">
              <div className="form-icon">
                <FaBuilding />
              </div>
              <div className="form-title">
                <h2>Department Details</h2>
              </div>
            </div>
            <form onSubmit={handleSubmit} className="department-form">
              <div className="form-group">
                <label htmlFor="departmentName">
                  <span className="label-text">Department Name</span>
                  <span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="departmentName"
                  value={name}
                  onChange={e => setName(e.target.value)}
                  placeholder="Enter department name."
                  required
                  disabled={loading}
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <label htmlFor="courseCenter">
                  <span className="label-text">Cost Center</span>
                  <span className="required">*</span>
                </label>
                <Select
                  id="courseCenter"
                  classNamePrefix="react-select"
                  isLoading={fetchingCenters}
                  isDisabled={loading || fetchingCenters}
                  options={costCenterOptions}
                  value={courseCenter}
                  onChange={setCourseCenter}
                  placeholder={fetchingCenters ? 'Loading cost centers...' : 'Select a cost center'}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: '48px',
                      borderRadius: '12px',
                      borderColor: state.isFocused ? '#667eea' : '#e5e7eb',
                      boxShadow: state.isFocused ? '0 0 0 3px rgba(102, 126, 234, 0.1)' : undefined,
                      background: state.isDisabled ? '#f3f4f6' : '#f9fafb',
                      fontSize: '16px',
                      color: '#374151',
                    }),
                    option: (base, state) => ({
                      ...base,
                      background: state.isSelected ? '#667eea' : state.isFocused ? '#e0e7ff' : '#fff',
                      color: state.isSelected ? '#fff' : '#1e293b',
                      fontWeight: state.isSelected ? 600 : 400,
                      fontSize: '16px',
                    }),
                  }}
                />
              </div>
              <div className="form-actions">
                <Link to="/hr/departments" className="cancel-button">
                  Cancel
                </Link>
                <button
                  type="submit"
                  className="submit-button"
                  disabled={loading || !name.trim() || !courseCenter}
                >
                  {loading ? (
                    <>
                      <FaSpinner className="spinner" />
                      <span>Creating Department...</span>
                    </>
                  ) : (
                    <>
                      <FaSave />
                      <span>Create Department</span>
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default CreateDepartment
